<template>
  <content-wrapper
    without-horizontal-spacing
    without-left-margin
    fill-height
    hide-search
    no-top-padding
    no-bottom-padding
  >
    <place-manager-surveys-table v-if="isPlaceManager" />
    <surveys-table v-else />
  </content-wrapper>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import { mapActions } from 'vuex';
import {
  DEFAULT_QUERY_FORMATTERS,
  DEFAULT_VALUE_GETTERS,
} from '@/constants/filters';
import ContentWrapper from '@/layouts/BrandLayout/Components/ContentWrapper';
import SurveysTable from '@/views/Brand/Surveys/_components/SurveysTable.vue';
import PlaceManagerSurveysTable from '@/views/Brand/Surveys/_components/PlaceManagerSurveysTable.vue';
import { SystemRole } from '@/api/requests/users';
import { useRoleChecker } from '@/composables/use-role-checker';

export default defineComponent({
  components: {
    SurveysTable,
    PlaceManagerSurveysTable,
    ContentWrapper,
  },
  setup(props, ctx) {
    const { checkRole } = useRoleChecker(ctx);
    const { setRouteConfig } = mapActions('routes', ['setRouteConfig']);

    const isPlaceManager = checkRole(SystemRole.PLACE_MANAGER);

    ctx.root.$nextTick(() => {
      setRouteConfig({
        route: ctx.root.$route,
        config: {
          queryFormatters: DEFAULT_QUERY_FORMATTERS,
          valueGetters: DEFAULT_VALUE_GETTERS,
        },
      });
    });

    return {
      isPlaceManager,
    };
  },
});
</script>
